import { toastError, toastSuccess } from "./guest-slices/other.slice"
import { checkTokenErr } from "../utils/helper"
import axios from "axios"

export const asyncThunkWrapper = async (
  axiosConfig,
  { dispatch, rejectWithValue },
  {
    successMsg = null,
    returnDataKey = "data",
    showToast = true
  } = {}
) => {
  try {
    const response = await axios(axiosConfig)

    if (response.data?.success) {
      if (showToast) dispatch(toastSuccess(successMsg || response?.data?.message))
      return response?.data?.[returnDataKey] || response.data
    } else {
      const newErr = response.data?.error || "Something went wrong here!"
      if (showToast) dispatch(toastError(newErr))
    }

    return response
  } catch (error) {
    checkTokenErr(error, dispatch)
    const newErr = error?.response?.data?.error || "Something went wrong!"
    if (showToast) dispatch(toastError(newErr))
    return rejectWithValue(error)
  }
}